<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
          title="Edit"
        >
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Fund Bucket Item Description
            </h4>
            <p class="category font-weight-thin">
              Edit Fund Bucket Item Description
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-container>
        <v-form
          ref="form"
          lazy-validation
        >
          <v-row>
            <v-col>
              <v-text-field
                v-model="localFundBucketItemDescription.description"
                v-validate="'required|alpha_spaces'"
                label="Description"
                :error-messages="errors.collect('description')"
                data-vv-name="description"  
              />
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              Edit
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      fundBucketItemDescription: Object,
    },

    data () {
      return {
        dialog: false,
        progressing: false,
        localFundBucketItemDescription: '',
      }
    },
    computed: {
      isDataChanged () {
        return _.isEqual(this.fundBucketItemDescription, this.localFundBucketItemDescription)
      },
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        } else {
          this.localFundBucketItemDescription = { ...this.fundBucketItemDescription }
        }
      },
    },

    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            if (!this.isDataChanged) {
              this.$api.fundBucketItemDescriptions().update(this.localFundBucketItemDescription.id, this.prepareFormData())
                .then((response) => {
                  if (response.status === 200) {
                    this.$emit('updated')
                    this.$snack({ color: 'success', message: response.data.message })

                    this.dialog = false
                  }
                }).catch((err) => {
                  console.log(err)
                  this.$snack({ color: 'error', message: err.response.statusText })
                }).then(() => {
                  this.progressing = false
                })
            } else {
              this.$snack({ color: 'warning', message: 'No update has been done' })
              this.progressing = false
              this.dialog = false
            }
          })
      },
      prepareFormData () {
        return {
          description: this.localFundBucketItemDescription.description,
        }
      },
    },
  }
</script>
